import {User} from "@/entities/user";
import {MobileNavBarItem} from "../../model/types";
import {useProfileNavigation} from "@/features/profile-navigation";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
import {useCatalogMenu} from "@/widgets/catalog-menu";
import {useLoginOrRegistrationModalStore} from "@/widgets/login-or-registration-modal";
import {useBasketStore} from "@/Stores/Site/Basket";

type Params = {
    isAuthenticated: boolean;
    user: User;
};

export const useMobileNavBar = (
    {
        isAuthenticated,
        user
    }: Params
) => {
    const basketCount = useBasketStore(state => state.basketCount);
    const openLoginOrRegistrationModal = useLoginOrRegistrationModalStore(s => s.actions.openModal);
    const openProfileNavigationModal = useProfileNavigation(s => s.actions.openModal);

    const catalogMenuDrawer = useCatalogMenu();

    const {subMenuStore, favouritesStore} = useStoreMobx();

    const activeOrders = user.ordersCount + user.refundsCount;

    return <MobileNavBarItem[]>[
        {
            id: "catalog",
            title: "Каталог",
            icon: "catalog",
            href: "/catalog",
            component: "button",
            onClick: catalogMenuDrawer.open,
        },
        {
            id: "profile",
            title: "Профиль",
            icon: "profile",
            svgClassName: "svgProfile",
            badge: isAuthenticated && activeOrders > 0,
            badgeClassName: "badgeProfile",
            href: "/home?profile=profile",
            component: "button",
            onClick: isAuthenticated ? openProfileNavigationModal : openLoginOrRegistrationModal,
        },
        {
            id: "main",
            icon: "main-logo-mobile",
            svgClassName: "svgLogo",
            href: "/",
            component: "link",
            onClick: subMenuStore.closeMobileSubMenu,
        },
        {
            id: "favorites",
            title: "Избранное",
            icon: "favoriteBorderOutlinedIcon",
            badge: favouritesStore.favouritesData.length > 0,
            badgeClassName: "badgeFavorites",
            href: "/favorites",
            component: "link",
            onClick: subMenuStore.closeMobileSubMenu,
        },
        {
            id: "basket",
            title: "Корзина",
            icon: "headerBasket",
            badge: basketCount || undefined,
            badgeClassName: "badgeBasket",
            href: "/basket",
            component: "basketButton",
            onClick: subMenuStore.closeMobileSubMenu,
        },
    ];
};
